module.exports = {
  adsetPublicUrl: 'https://adset.apester.com',
  analyticsBaseUrl: 'https://analytics.apester.com',
  usersBaseUrl: 'https://users.apester.com',
  interactionBaseUrl: 'https://interaction.apester.com',
  editorBaseUrl: 'https://app.apester.com',
  campaignBaseUrl: 'https://campaign.apester.com',
  campaignApiPublicUrl: 'https://campaign-api.apester.com',
  adsetApiPublicUrl: 'https://adset-api.apester.com',
  consoleBaseUrl: 'https://console.apester.com',
  authBaseUrl: 'https://auth.apester.com',
  eventsPublicUrl: 'https://events.apester.com',
  imagesUrl: '//img.apester.com',
  imagesNewUrl: 'https://img.apester.com',
  staticBucket: 'https://static.apester.com',
  vreminiUrl: 'https://vremini.apester.com',
  playerBaseUrl: 'https://renderer.apester.com/v2/',
  planApiUrl: 'https://plans.apester.com',
  portalUrl: 'https://portal.apester.com',
  jobsUrl: 'https://jobs-api.apester.com',
  paymentsUrl: 'https://payments.apester.com',
  wixIntegrationUrl: 'https://wix-integration.apester.com',
  stripePK: 'pk_live_YL6LSULaHEGhq0GpzvPoulFe00SJvfnPkA',
  webhooksBaseUrl: 'https://webhooks.apester.com',
  enableHeap: false,
};
